import { createContext, useContext } from 'react'

type ConsentContextType = {
  aiConsent: boolean | null | undefined
  grantConsent: () => Promise<void>
}

export const ConsentContext = createContext<ConsentContextType>({
  aiConsent: null,
  grantConsent: async () => {},
})

export const useConsent = () => useContext(ConsentContext)
